import React, { useState } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Button } from 'antd'
import { ExpandOutlined, CompressOutlined, HomeOutlined } from '@ant-design/icons'
import SelectLang from '@/components/selectLang'
import { Row, Col } from 'antd'
import { exitFullscreen, isFullScreen } from '@/utils/common'

import '@/pages/layout/header/Header.less'
const defaultFontSize = 20
const PhoneHeader = props => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const history = useHistory()
  const [fullScreen, setFullScreen] = useState(false)

  const zoomInOrOutHtml = () => {
    return (
      <div
        id="zoomInOrOut"
        style={{ marginLeft: '20px' }}
        onClick={() => {
          if (fullScreen) {
            setFullScreen(false)
            if (isFullScreen()) {
              exitFullscreen()
            }
          } else {
            setFullScreen(true)
            if (!isFullScreen()) {
              props.openFullscreen()
            }
          }
        }}
      >
        {fullScreen ? (
          <CompressOutlined style={{ fontSize: defaultFontSize * deviceSize }} />
        ) : (
          <ExpandOutlined style={{ fontSize: defaultFontSize * deviceSize }} />
        )}
      </div>
    )
  }

  const goLogin = () => {
    let str = '/rf/login'
    if (localStorage.getItem('qrLogin')) {
      str = localStorage.getItem('qrLogin')
    }
    history.push(str)
  }

  return (
    <div className="gnav">
      <div className="gnav-bar">
        <Row type="flex" justify="space-between" align="middle">
          <Col span={2}></Col>
          <Col span={14} className="tool-bar">
            <Button
              type="text"
              icon={<HomeOutlined style={{ fontSize: defaultFontSize * deviceSize }} />}
              style={{ color: '#fff', margin: '10px 20px' }}
              onClick={goLogin}
            />
            <SelectLang />
            {zoomInOrOutHtml()}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default withRouter(PhoneHeader)
